import React, { useState, useEffect, useCallback } from "react";
import api from "../services/api.tsx";
import { useAuth } from "../contexts/AuthContext.tsx";
import { useNavigate } from "react-router-dom";
import { useError } from "../contexts/ErrorContext.tsx";

const RegisterPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { setError } = useError();

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
    phoneNumber: "",
    address: "",
    userType: "Bireysel",
  });

  // Sadece ilk renderda yönlendirme kontrolü
  useEffect(() => {
    if (isAuthenticated) navigate("/");
  }, [isAuthenticated, navigate]);

  // useCallback ile referansı sabit tut
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }, []);

  const handleRegister = useCallback(async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await api.post("/api/auth/register", formData);
      alert("Kayıt başarılı! Şimdi giriş yapabilirsiniz.");
    } catch (error) {
      alert("Kayıt başarısız!");
      setError(
        error.response?.data?.Message?.trim() ||
        error.response?.data?.[0]?.description?.trim() ||
        "Bir hata oluştu."
      );
    }
  }, [formData, setError]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <form onSubmit={handleRegister} className="bg-white p-8 rounded shadow-md w-96">
        <h2 className="text-2xl font-bold mb-6 text-center">Kayıt Ol</h2>
        <input name="fullName" placeholder="Ad Soyad" className="w-full mb-3 p-2 border rounded" value={formData.fullName} onChange={handleChange} />
        <input name="email" placeholder="E-posta" className="w-full mb-3 p-2 border rounded" value={formData.email} onChange={handleChange} />
        <input name="password" type="password" placeholder="Şifre" className="w-full mb-3 p-2 border rounded" value={formData.password} onChange={handleChange} />
        <input name="phoneNumber" placeholder="Telefon" className="w-full mb-3 p-2 border rounded" value={formData.phoneNumber} onChange={handleChange} />
        <input name="address" placeholder="Adres" className="w-full mb-3 p-2 border rounded" value={formData.address} onChange={handleChange} />
        <select name="userType" className="w-full mb-4 p-2 border rounded" value={formData.userType} onChange={handleChange}>
          <option value="Bireysel">Bireysel</option>
          <option value="Kurumsal">Kurumsal</option>
        </select>
        <button className="bg-green-500 text-white w-full p-2 rounded hover:bg-green-600">
          Kayıt Ol
        </button>
      </form>
    </div>
  );
};

export default RegisterPage;